import { serverTimestamp, type FieldValue } from 'firebase/firestore'
import {
  typedCollection,
  typedDoc,
  getCollection,
  updateDocument,
  deleteDocument,
  addDoc,
  orderBy,
} from '@/lib/firebase/firestore'
import type { ServiceCategoryDocument } from '@/types'

const categoriesCol = () => typedCollection<ServiceCategoryDocument>('serviceCategories')

type CategoryCreatePayload = Omit<ServiceCategoryDocument, 'id' | 'createdAt' | 'updatedAt'> & {
  createdAt: FieldValue
  updatedAt: FieldValue
}

function toServiceKey(str: string): string {
  return str.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/(^_|_$)/g, '')
}

export const adminServiceCategoriesService = {
  async createCategory(title: string, order: number, serviceKey?: string): Promise<string> {
    const payload: CategoryCreatePayload = {
      title: title.trim(),
      serviceKey: serviceKey?.trim() || toServiceKey(title),
      order,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    }
    const ref = await addDoc(categoriesCol(), payload as unknown as ServiceCategoryDocument)
    return ref.id
  },

  async updateCategory(
    id: string,
    data: Partial<Pick<ServiceCategoryDocument, 'title' | 'serviceKey' | 'order'>>
  ): Promise<void> {
    const ref = typedDoc<ServiceCategoryDocument>('serviceCategories', id)
    const updates: Record<string, unknown> = { updatedAt: serverTimestamp() }
    if (data.title !== undefined) updates.title = data.title.trim()
    if (data.serviceKey !== undefined) updates.serviceKey = data.serviceKey.trim()
    if (data.order !== undefined) updates.order = data.order
    await updateDocument(ref, updates as unknown as ServiceCategoryDocument)
  },

  async deleteCategory(id: string): Promise<void> {
    const ref = typedDoc<ServiceCategoryDocument>('serviceCategories', id)
    await deleteDocument(ref)
  },

  async getAllCategories(): Promise<Array<ServiceCategoryDocument & { id: string }>> {
    return getCollection(categoriesCol(), orderBy('order', 'asc'))
  },
}
